import { useContext, useEffect, useState } from "react"
import { StyleContext } from "../providers/StyleContextProvider"
import { JobView } from "../models/JobView";
import { useMediaQuery } from "react-responsive";
import useErrorPage from "../hooks/useErrorPage";
import { useParams } from "react-router-dom";
import { getPublishedJob } from "../services/JobService";
import { Footer } from '../components/Shared/Footer';
import { Header } from '../components/Shared/Header';
import { JobViewLoader } from "../components/Loaders/JobViewLoader";
import { Helmet } from "react-helmet-async";
import { VerticalJobDetailCard } from "../components/Shared/VerticalJobDetailCard";
import { JobApply } from "../components/JobView/JobApply";
import { JobViewTexts as Texts } from '../helpers/LayoutTexts';
import { Share } from "../components/Shared/Share";
import { JobSectors } from "../components/JobView/JobSectors";
import { JobOrganizationCard } from "../components/Shared/JobOrganizationCard";
import { ReactComponent as DropDownIcon } from '../assets/svg/drop_down.svg';
import 'quill/dist/quill.snow.css';

export const JobPreviewPage: React.FC = () => {
    const params = useParams();
    const jobId = +params.jobId!;
    const applyEnable = false;
    const styleContext = useContext(StyleContext);
    const [styles, setStyles] = useState<any>(styleContext.getComponentStyle("jobViewPage"));
    const [loading, setLoading] = useState<boolean>(true);
    const [jobView, setJobView] = useState<JobView>();
    const [jobVideoUrl, setJobVideoUrl]= useState<string>();
    const [isJobAdExpand, setIsJobAdExpand] = useState<boolean>(true);
    const isMobile = useMediaQuery({ query: "(max-width: 786px)"});
    const [toErrorPage] = useErrorPage();
    
    useEffect(() => {
        setStyles(styleContext.getComponentStyle("jobViewPage"));
    }, [isMobile]);

    useEffect(() => {
        getJobView();
    }, [jobId]);

    async function getJobView() {
        await getPublishedJob(jobId)
        .then((publishedJob: JobView) => {
            if (publishedJob) {
                setJobView(publishedJob);
                setLoading(false);
            }
            if(publishedJob.jobItem.videoUrl) {
                const embedUrl = publishedJob.jobItem.videoUrl.replace("watch?v=", "embed/");
                setJobVideoUrl(embedUrl);
            }
        })
        .catch((error) => {
            toErrorPage(error);
        });
    }

    const saveJob = () => {}

    const handleJobAdButtonClick = () => {
        setIsJobAdExpand((prev) => !prev);
    }

    return (
        <>
            <Header 
                styleSheet="jobViewHeader" 
                searchEnable={false} 
                jobTitle={jobView?.jobTitle} 
                organization={jobView?.organization.organizationName} 
                isDisabilityFriendly={jobView?.jobItem.disabilityFriendly} 
                backButtonEnable={false} 
            />
            {loading ? <JobViewLoader styles={styles} /> :
                <div>
                    <Helmet>
                        <title>{jobView?.jobTitle}</title>
                    </Helmet>
                    <div style={styles.baseWrapper}>
                        <div style={styles.leftWrapper}>
                            {/* This is loading only mobile platform */}
                            <div style={styles.mobileDetailCard}>
                                <VerticalJobDetailCard 
                                    job={jobView!.jobItem} 
                                    isSaved={false} 
                                    applyEnable={applyEnable} 
                                    education={jobView!.education} 
                                    experience={jobView!.experience} 
                                    salaryRange={jobView!.salaryRange} 
                                    benefits={jobView!.benefits} 
                                    saveJob={saveJob} 
                                />
                            </div>
                            <div style={styles.description}>
                                <div className="ql-container ql-snow" style={{ border: 'none' }}>
                                    <div className="jobviewDescription ql-editor" dangerouslySetInnerHTML={{ __html: jobView?.jobInfo! }}/>
                                </div>
                            </div>
                            {jobView?.jobHasImage && <div style={{ ...styles.jobAdContainer, ...(isJobAdExpand && styles.jobAdContainer.expand) }}>
                                <div style={styles.expandButton} onClick={handleJobAdButtonClick}>
                                    {Texts.jobAd}
                                    <span style={styles.expandButton.iconWrapper}>
                                        <DropDownIcon style={{ ...styles.expandButton.icon, ...(isJobAdExpand && styles.expandButton.expandIcon) }} />
                                    </span>
                                </div>
                                {isJobAdExpand && <img src={jobView?.jobImageUri} style={styles.jobAd} alt={jobView.jobTitle} />}
                            </div>}
                            <br />
                            <div style={styles.share.wrapper}>
                                <div style={styles.share.text}>{Texts.unemployment}</div>
                                <Share styles={styles.share} jobId={jobView!.jobId} jobTitle={jobView!.jobTitle} organizationName={jobView!.organization.organizationName}/>
                            </div>
                            {jobVideoUrl && <div style={styles.video}>
                                <iframe src={jobVideoUrl} style={styles.video.youtube} frame-border="0" data-allow="autoplay; encrypted-media;" allowFullScreen></iframe>
                            </div>}
                        </div>
                        <div style={styles.rightWrapper}>
                            {/* This is loading only desktop platform */}
                            <div style={styles.desktopDetailCard}>
                                <VerticalJobDetailCard 
                                    job={jobView!.jobItem} 
                                    isSaved={false} 
                                    applyEnable={applyEnable} 
                                    education={jobView!.education} 
                                    experience={jobView!.experience} 
                                    salaryRange={jobView!.salaryRange} 
                                    benefits={jobView!.benefits} 
                                    saveJob={saveJob} 
                                />
                            </div>
                            <JobSectors styles={styles.jobSectors} sectors={jobView!.sectors} />
                            <JobOrganizationCard styles={styles.organizationCard} organization={jobView!.organization} buttonText={"ADD TO FAVOURITE"} />
                        </div>
                    </div>
            </div>}
            <Footer/>
        </>
    );
}